{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Моля, въведете имейла адреса си.",
      "ERROR": "Please enter a valid email."
    },
    "API": {
      "SUCCESS_MESSAGE": "Password reset link has been sent to your email.",
      "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
    },
    "SUBMIT": "Изпращане"
  }
}
